import $ from '$';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as d3 from 'd3';
import Tooltip from '@material-ui/core/Tooltip';

import BootstrapModal from 'utils/BootstrapModal';
import {
    Header,
    SingleCurveBody,
    MultipleCurveBody,
    molecularGraphBody,
    sankeyPlotGraphBody,
} from './BootstrapBodyPart';
import {
    COLLAPSE_WITH_Mortality120,
    getDoseResponsesUrl,
    getSankeyPlotUrl,
    integrativeHandleCellClick,
    NO_COLLAPSE,
} from '../shared';

import { getLog10AxisFunction } from 'utils/d3';
import DoseResponse from './DoseResponse';

class Heatmap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
        };
        this.handleResize = this.handleResize.bind(this);
    }

    renderPlot = function(el, data, legendData) {
        $(el).empty();
        let margin = {
                top: 40,
                left: 10,
                bottom: 40,
                right: 40,
                axisLeft: 290,
                axisTop: 300,
                legend: 900,
            },
            cellSize = 50,
            xMap = _.groupBy(data, 'x'),
            yMap = _.groupBy(data, 'y'),
            ontologyType = this.props.ontologyType,
            handleXLabelClick = function(label) {
                // console.log(label);
                let cells = xMap[label];
                let cell = {
                    developmental_defect_grouping_general:
                        cells[0].developmental_defect_grouping_general,
                    ontologyGroupName: cells[0].ontologyGroupName,
                    protocol_source: cells[0].protocol_source,
                    ontologyType: ontologyType,
                };
                if (cell.developmental_defect_grouping_general && cell.protocol_source) {
                    new BootstrapModal(Header, sankeyPlotGraphBody, {
                        title: label.replace(/:/g, ' +'),
                        cells: cell,
                    });
                }
            },
            // draw y-axis
            handleYLabelClick = function(label) {
                // console.log(label);

                let cells = yMap[label],
                    casrns = [...new Set(cells.map((item) => item.casrn))],
                    dtxsids = [...new Set(cells.map((item) => item.dtxsid))];

                new BootstrapModal(Header, molecularGraphBody, {
                    title: `${dtxsids[0]} // ${label} //  molecularGraph  ZWTBD`,
                    dtxsid: dtxsids[0],
                });
            },
            mouseover = function(d) {
                tooltip.style('opacity', 1);
            },
            mousemove = function(d) {
                if (d.endPointList) {
                    tooltip
                        .html(
                            `<span style="font-size: 15px; font-weight: bold;">
                    ${d.devtoxEndPointList.length} out of ${d.endPointList.length} endpoints are significant
                </span>`
                        )
                        .style('left', d3.event.pageX - 200 + 'px')
                        .style('top', d3.event.pageY - 30 + 'px')
                        .style('opacity', 1.0);
                }
            },
            mouseleave = function(d) {
                tooltip.style('opacity', 0);
            },
            // xasix is column, yasix is row
            xasix = d3
                .map(data, function(d) {
                    return d.x;
                })
                .keys()
                .sort(),
            yasix = d3
                .map(data, function(d) {
                    return d.y;
                })
                .keys()
                .sort(),
            width =
                xasix.length * cellSize +
                margin.axisLeft +
                margin.left +
                margin.right +
                margin.legend,
            height = yasix.length * cellSize + margin.axisTop + margin.top + margin.bottom,
            chartHeight = height - (margin.top + margin.bottom + margin.axisTop),
            chartWidth = width - (margin.left + margin.right + margin.axisLeft + margin.legend),
            // how we get this 900,  check cellSize = 30.  30*30 = 900.
            square = d3
                .symbol()
                .type(d3.symbolSquare)
                .size(cellSize * cellSize),
            // Create the svg area

            svg = d3
                .select(el)
                .append('svg')
                .attr('width', Math.max(1000, width + margin.left + margin.right))
                .attr('height', Math.max(1000, height + margin.left + margin.right))
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
            tooltip = d3
                .select(el)
                .append('div')
                .attr('class', 'tooltip')
                .style('opacity', 0.0);

        // addStripMask(svg);

        let axisLayer = svg
            .append('g')
            .classed('axisLayer', true)
            .attr('width', width)
            .attr('height', height);

        // draw xy-axis
        let xScale = d3
            .scaleBand()
            .domain(xasix)
            .range([0, chartWidth]);
        let yScale = d3
            .scaleBand()
            .domain(yasix)
            .range([0, chartHeight]);

        let xAxis = d3.axisTop(xScale).tickSizeOuter(0);
        let yAxis = d3.axisLeft(yScale).tickSizeOuter(0);

        axisLayer
            .append('g')
            .attr(
                'transform',
                `translate(${margin.left + margin.axisLeft}, ${margin.top + margin.axisTop})`
            )
            .attr('class', 'axis y')
            .call(yAxis)
            .style('font-size', 15)
            .selectAll('text');
        // .style('cursor', 'pointer')
        // .on('click', handleYLabelClick)

        axisLayer
            .append('g')
            .attr(
                'transform',
                `translate(${margin.left + margin.axisLeft}, ${margin.top + margin.axisTop})`
            )
            .attr('class', 'axis x')
            .call(xAxis)
            .style('font-size', 15)
            .selectAll('text')
            .attr('dx', '.8em')
            .attr('dy', '.55em')
            .attr('transform', 'rotate(-65)')
            .style('text-anchor', 'start')
            .style('cursor', 'pointer')
            .on('click', handleXLabelClick);

        let chartLayer = svg
            .append('g')
            .classed('chartLayer', true)
            .attr('width', chartWidth)
            .attr('height', chartHeight)
            .attr(
                'transform',
                `translate(${margin.left + margin.axisLeft}, ${margin.top + margin.axisTop})`
            );

        chartLayer
            .append('rect')
            .attr('x', xScale.range()[0])
            .attr('y', yScale.range()[0])
            .attr('width', xScale.range()[1])
            .attr('height', yScale.range()[1])
            .attr('fill', 'transparent')
            .style('stroke', 'black')
            .style('stroke-width', 2);

        chartLayer
            .selectAll('.square')
            .data(data)
            .enter()
            .append('path')
            .attr('class', 'square')
            .attr('d', square)
            .attr('fill', (d) => d.fill)
            .attr(
                'transform',
                (d) =>
                    `translate(${xScale(d.x) + xScale.bandwidth() / 2}, ${yScale(d.y) +
                        yScale.bandwidth() / 2})`
            )
            .style('stroke', 'black')
            .style('stroke-width', '0.8')
            .style('cursor', 'pointer')
            .on('mouseover', mouseover)
            .on('mousemove', mousemove)
            .on('mouseleave', mouseleave)
            .on('click', integrativeHandleCellClick);

        // draw legend, this legend length, size is fixed.
        // 2 cases, discrete = activity,  continuous = BMC, different legned form.
        let legendLayer = svg
            .append('g')
            .classed('legendLayer', true)
            .attr('transform', `translate(${width - margin.legend},${margin.top})`);

        legendLayer
            .append('text')
            .attr('className', 'legend-text')
            .attr('x', 0)
            .attr('y', 0)
            .attr('transform', (d, i) => `translate(25, ${margin.axisTop + (cellSize - 20) / 2})`)
            .html('Developmental Toxicity Classification')
            .style('font-size', 20);

        legendLayer
            .selectAll('.legendText') // Use a specific class for the selection
            .data(legendData.values)
            .enter()
            .append('text')
            .attr('className', 'legend-text')
            .attr(
                'transform',
                (d, i) =>
                    `translate(${15 + cellSize}, ${i * cellSize +
                        margin.axisTop +
                        (cellSize - 20) / 2 +
                        cellSize})`
            )
            .text((d) => d.label);
        legendLayer
            .selectAll('.legendRect') // Use a specific class for the selection
            .data(legendData.values)
            .enter()
            .append('rect')
            .attr('width', cellSize - 20)
            .attr('height', cellSize - 20)
            .attr('fill', (d) => d.fill)
            .attr(
                'transform',
                (d, i) => `translate(25, ${i * cellSize + margin.axisTop + cellSize})`
            )
            .style('stroke', 'black')
            .style('stroke-width', '1');
    };

    _unrenderPlot() {
        if (this.refs.svg === undefined) {
            return;
        }
        window.removeEventListener('resize', this.handleResize);
        this.refs.svg.innerHTML = '';
    }

    _renderPlot() {
        if (this.refs.svg === undefined) {
            return;
        }
        this._unrenderPlot();
        // this is bootstrap plot svg
        this.renderPlot(this.refs.svg, this.props.data, this.props.legendData);
        window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
        this._renderPlot();
    }

    componentDidMount() {
        this._renderPlot();
    }

    componentDidUpdate() {
        this._renderPlot();
    }

    componentWillUnmount() {
        this._unrenderPlot();
    }

    render() {
        return <div id="IA_heatmap01" ref="svg" />;
    }
}

Heatmap.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            x: PropTypes.string,
            y: PropTypes.string,
            fill: PropTypes.string,
        })
    ).isRequired,
    legendData: PropTypes.shape({
        values: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                fill: PropTypes.string,
                chemical_casrn: PropTypes.string,
                readout_id: PropTypes.number,
                title: PropTypes.string,
            })
        ),
        colorScaleFunction: PropTypes.func,
        legendScale: PropTypes.func,
    }).isRequired,
    ontologyType: PropTypes.number.isRequired,
};

export default Heatmap;



// WEBPACK FOOTER //
// ./seazit/assets/seazit/components/Heatmap.js